import noProjectsImage from '../../../../assets/icons/no-projects.png';
import { Flex, Text } from '@mantine/core';

export default function NoProjects() {
  return (
    <Flex className="empty" direction="column" align="center" gap="16">
      <img src={noProjectsImage} width={120} />
      <Text>Your Project list is empty.</Text>
    </Flex>
  );
}
